import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Croix = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.29 80.29">
  <G fill={color}>
    <Path d="M77.37,23.84h-20.92V2.92c0-1.61-1.3-2.92-2.92-2.92h-26.78c-1.61,0-2.92,1.3-2.92,2.92v20.92H2.92c-1.61,0-2.92,1.3-2.92,2.92v26.78c0,1.61,1.3,2.92,2.92,2.92h20.92v20.92c0,1.61,1.3,2.92,2.92,2.92h26.78c1.61,0,2.92-1.31,2.92-2.92v-20.92h20.92c1.61,0,2.92-1.31,2.92-2.92v-26.78c0-1.61-1.3-2.92-2.92-2.92ZM54.02,43.06h-10.97v10.97c0,1.61-1.3,2.92-2.92,2.92s-2.92-1.31-2.92-2.92v-10.97h-10.97c-1.61,0-2.92-1.31-2.92-2.92s1.3-2.92,2.92-2.92h10.97v-10.97c0-1.61,1.3-2.92,2.92-2.92s2.92,1.3,2.92,2.92v10.97h10.97c1.61,0,2.92,1.3,2.92,2.92s-1.3,2.92-2.92,2.92Z"/>
  </G>
</Svg>
);
};

export default Croix;
